import CarouselCard from 'components/OfferList/OfferCards/CarouselCard'
import React from 'react'
import offerPageURL from 'lib/offer/offerPageURL'
import BookmarkButton from 'tripPlanner/components/Bookmark/BookmarkButton'
import OfferBadgeTag from 'components/Common/OfferBadgeTag'
import LabelGroup from 'components/Luxkit/Label/LabelGroup'
import LEOfferPriceDetails from './LEOfferPriceDetails'

interface Props {
  offer: App.Offer | App.OfferSummary
  onClick: () => void
  className?: string;
}

function TourOfferCard({
  offer,
  onClick,
  className,
}: Props) {
  return (
    <CarouselCard
      className={className}
      bookmarkButton={<BookmarkButton offer={offer} />}
      image={offer.image}
      location={offer.location}
      title={offer.name}
      offerPriceDetails={<LEOfferPriceDetails offer={offer} />}
      offerUrl={offerPageURL(offer)}
      onClick={onClick}
      urgencyLabels={<LabelGroup>
        {offer.badge && <OfferBadgeTag badge={offer.badge} />}
      </LabelGroup>}
    />
  )
}

export default TourOfferCard
